const initialState = {
  dialog: {
    dialogName: null,
    dialogTitle: null,
    dialogType: null,
    visible: false,
    callback: null,
    action: null,
    payload: null
  },
  dialogs: {}
};
export default {
  namespaced: true,
  state: {...initialState},
  getters: {
    dialog: (state) => {
      return state.dialog;
    },
    dialogs: (state) => {
      return state.dialogs
    },
    dialogsMap: (state) => {
      return Object.values(state.dialogs)
    }
  },
  mutations: {
    /**
     *
     * @param state
     * @param dialogName
     * @param dialogTitle
     * @param dialogType
     * @param callback
     * @param action
     * @param payload
     * @param multiple
     * @constructor
     */
    SHOW_DIALOG(
      state,
      {
        dialogName = initialState.dialog.dialogName,
        dialogTitle = initialState.dialog.dialogTitle,
        dialogSubtitle = initialState.dialog.dialogSubtitle,
        dialogType = initialState.dialog.dialogType,
        callback = initialState.dialog.callback,
        action = initialState.dialog.action,
        payload = initialState.dialog.payload,
        multiple = false
      }) {
      const dialog = {
        dialogName, dialogTitle, dialogSubtitle, dialogType, callback, action, payload,
        visible: true
      }

      if (multiple) {
        state.dialogs = {
          ...state.dialogs,
          [dialogName]: dialog
        }
      } else {
        state.dialog = dialog
      }
    },
    CLOSE_DIALOG(state, {dialogName}) {
      if (dialogName && state.dialogs[dialogName]?.dialogName) {
        state.dialogs = Object.entries(state.dialogs).filter(x => x.dialogName === dialogName).reduce((r, [k, v]) => ({ [k]: v }), {})
      }
      else state.dialog = initialState.dialog
    },
    CLEAR_DIALOG_NAME(state, {dialogName}) {
      state.dialog.dialogName = dialogName;
    }
  },
  actions: {
    closeDialog: async function ({commit}, { dialogName }) {
      await commit('CLOSE_DIALOG', { dialogName });
    },
    clearDialog: async function ({commit}) {
      commit('CLEAR_DIALOG_NAME', {dialogName: null})
    }
  }
};
